<template>
    <button v-if="this.disabled == true"  :style='this.style' v-bind:class="this.type" disabled class='btn disabled neue fsp14'>
        <slot name="currLogo"></slot>
        <i v-if='this.icon_i' class='item-i mr-1' :class='this.icon_i'></i>
        <span v-if="this.name" class="flex-grow-1 lh20">{{this.name}}</span>
        <slot></slot>
    </button>
    <button v-else class='btn neue fsp14' :style='this.style' v-bind:class="this.type">
        <slot name="currLogo"></slot>
        <i v-if="this.icon_i.length > 1" class='item-i mr-1' :class='this.icon_i'></i>
        <span v-if="this.name" class="flex-grow-1 lh20">{{this.name}}</span>
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        name: [String],
        type: {
            type: String,
            default: 'btn-primary'
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        icon_i: {
            type: String,
            default: '',
        },
        style: {
            type: String,
            default: '',
        }
    },
}
</script>

<style lang="scss" scoped>
</style>